export default {"src":"/_next/static/media/toRegist_active.189d7880.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};